import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormlyModule} from '@ngx-formly/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormlyFieldDatePickerComponent} from './formly-field-date-picker.component';
import {DatePickerModule, InputModule, TooltipModule} from 'ng-design-system';
import {I18nModule} from '@spartacus/core';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {DcpDateFormatterModule, IconButtonTooltipModule} from '@dcp/configurator';

@NgModule({
  declarations: [FormlyFieldDatePickerComponent],
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'date-picker',
          component: FormlyFieldDatePickerComponent,
        },
      ],
    }),
    FormsModule,
    DatePickerModule,
    TooltipModule,
    InputModule,
    DcpDateFormatterModule,
    IconButtonTooltipModule,
  ],
  exports: [
    FormlyFieldDatePickerComponent
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class FormlyDatePickerModule {
}
